import * as Yup from 'yup';

export const CheckListSchema = Yup.object().shape({
  name: Yup.string().required('Nome obrigatório').max(100, 'Máximo de 100 caracteres'),
  description: Yup.string().required('Descrição obrigatória').max(255, 'Máximo de 255 caracteres'),
  type: Yup.number().required('Tipo obrigatório'),

  defaultCostCenter: Yup.boolean(),

  costCentersId: Yup.array()
    .of(Yup.number())
    .when('defaultCostCenter', {
      is: true,
      then: schema =>
        schema.min(1, 'Selecione ao menos um centro de custo').required('Centro de custo obrigatório'),
      otherwise: schema => schema.notRequired(),
    }),

  questions: Yup.array().of(
    Yup.object().shape({
      checklist_id: Yup.number(),
      order: Yup.number(),
      required: Yup.boolean(),
    }),
  ),
  clients: Yup.array()
    .of(
      Yup.object().shape({
        id: Yup.number(),
        label: Yup.string(),
      }),
    )
    .nullable(),
  negotiation: Yup.object().nullable(),
  vehicleType: Yup.array().of(
    Yup.object().shape({
      id: Yup.number(),
      name: Yup.string(),
    }),
  ),
  hasDollyImplement: Yup.boolean(),
  implementType: Yup.array()
    .of(
      Yup.object().shape({
        id: Yup.number(),
        name: Yup.string(),
      }),
    )
    .when(['vehicleType', 'type'], {
      is: (vehicleType, type) => {
        const list = Array.isArray(vehicleType) ? vehicleType : [];
        return !!list.find(({ name }) => name === 'Cavalo Mecânico') && type === 1;
      },
      then: (schema) =>
        schema
          .of(
            Yup.object().shape({
              id: Yup.number(),
              name: Yup.string(),
            }),
          )
          .when('hasDollyImplement', {
            is: true,
            then: (innerSchema) =>
              innerSchema
                .min(
                  2,
                  'Ao selecionar Dolly como implemento será necessário dois tipos de implementos',
                )
                .required(
                  'Ao selecionar Dolly como implemento será necessário dois tipos de implementos',
                ),
            otherwise: (innerSchema) =>
              innerSchema
                .min(1, 'Selecione pelo menos um tipo de implemento')
                .required('Implemento obrigatório'),
          }),
      otherwise: (schema) => schema.nullable(),
    }),
  vehicleBodyType: Yup.array()
    .of(
      Yup.object().shape({
        id: Yup.number(),
        name: Yup.string(),
      }),
    )
    .when('vehicleType', {
      is: (vehicleType) => (Array.isArray(vehicleType) ? vehicleType.length > 0 : false),
      then: (schema) =>
        schema
          .of(
            Yup.object().shape({
              id: Yup.number(),
              name: Yup.string(),
            }),
          )
          .min(1, 'Informe uma carroceria')
          .required('Carroceria obrigatória'),
      otherwise: (schema) => schema.nullable(),
    }),
  branchOffices: Yup.array()
    .of(
      Yup.object().shape({
        id: Yup.number(),
        name: Yup.string(),
      }),
    )
    .min(1, 'Informe ao menos uma filial')
    .required('Informe ao menos uma filial'),
});
